import { Route, Switch, Redirect } from "react-router-dom";

import { Alert, ReduxProtectedRoute } from "@leap4/frontend";
import { BACKEND_SERVICE_NAME, requiredAuthRoles } from "../../config/generals";
import Login from "../auth/Login/Login";
import { urlService } from "./urlsService";

import DashboardModule from "../modules/dashboard";
import ExplorerModule from "../modules/dashboard/explorer";
import PublishersModule from "../modules/dashboard/publishers";
import PublisherWorkspace from "../modules/dashboard/publishers/workspace";
import ReportingModule from "../modules/reporting";
import CampaignsModule from "../modules/campaigns";
import CampaignForm from "../modules/campaigns/CampaignForm";
import AccessManagerModule from "../modules/accessManager";
import ApiKeysModule from "../modules/apiKeys";
import AdvancedTargetingModule from "../modules/advancedTargeting";
import ConversionUploadsModule from "../modules/conversionUploads";
import PredictionAccuracy from '../modules/predictionAccuracy';
import BatchDetail from "../modules/conversionUploads/BatchDetail";

const Routes = () => {
    return (
        <section className="container">
            <Alert />
            <Switch>
                <Route exact path="/login" component={Login} />

                {/************** DASHBOARD — landing page *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={DashboardModule} path={urlService.app()} />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={ExplorerModule} path={urlService.dashboardExplorer()} />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={PublisherWorkspace} path={urlService.dashboardPublisher()} />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={PublishersModule} path={urlService.dashboardPublishers()} />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={DashboardModule} path={urlService.dashboard()} />
                <Redirect from="/home" to={urlService.dashboard()} />

                {/************** REPORTING *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={ReportingModule} path={urlService.reporting()} />

                {/************** CAMPAIGNS *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={CampaignForm} path={urlService.campaignNew()} />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={CampaignForm} path={urlService.campaignEdit()} />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={CampaignsModule} path={urlService.campaigns()} />

                {/************** ACCESS MANAGER *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={AccessManagerModule} path={urlService.accessManager()} />

                {/************** API KEYS *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={ApiKeysModule} path={urlService.apiKeys()} />

                {/************** ADVANCED TARGETING *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={AdvancedTargetingModule} path={urlService.advancedTargeting()} />

                {/************** PREDICTION ACCURACY *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={PredictionAccuracy} path={urlService.predictionAccuracy()} />

                {/************** CONVERSION UPLOADS *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={BatchDetail} path={urlService.conversionUploadBatch()} />
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={ConversionUploadsModule} path={urlService.conversionUploads()} />

                <Route component={Login} />
            </Switch>
        </section>
    )
};

export default Routes;
